/* ==========================================================================
   Milos Atelier — commande à la livraison, pixels publicitaires, preuve sociale
   Remplace l'application Webi Leadform. Même logique que les landings (trench.milos.fit) :
   le navigateur ne décide de rien. Prix, tarifs de livraison et total sont recalculés par
   le CRM MILOS à la réception de la commande ; ici on affiche et on envoie.
   ========================================================================== */
(() => {
  'use strict';

  const C = (window.theme && window.theme.cod) || null;
  if (!C) return;

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const S = window.Shopify || {};
  // Aperçu d'un thème non publié ou éditeur : aucun pixel, et la commande part en « essai »
  // (le CRM ne prévient ni Telegram ni les régies, et Shopify la marque « test »).
  const APERCU = !!(S.designMode || (S.theme && S.theme.role && S.theme.role !== 'main'));

  const store = {
    get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) { /* stockage indisponible */ } }
  };
  const money = (da) => {
    const f = window.MilosTheme && window.MilosTheme.formatMoney;
    return f ? f(Math.round(da) * 100) : new Intl.NumberFormat('fr-FR').format(Math.round(da)) + ' DA';
  };
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const pause = (ms) => new Promise((r) => setTimeout(r, ms));

  /* ------------------------------------------------------------------------
     1. Contexte publicitaire
     Les identifiants de clic et les UTM arrivent sur la première page vue (souvent l'accueil
     ou une collection) : on les garde pour la session, pour les avoir au moment de commander.
     ------------------------------------------------------------------------ */
  const CLES_PUB = ['fbclid', 'ttclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id'];
  const q = new URLSearchParams(location.search);
  CLES_PUB.forEach((k) => { const v = q.get(k); if (v) store.set('milos_' + k, v.slice(0, 300)); });
  // Première page de la visite, avec ses paramètres, et le site d'où l'on arrive (Instagram,
  // Facebook, TikTok, Google…) : le CRM en déduit la provenance notée sur la commande Shopify,
  // comme le « full_url » de Webi. Le référent n'est gardé que s'il est extérieur à la boutique.
  if (!store.get('milos_entree')) {
    store.set('milos_entree', location.href.slice(0, 600));
    let ref = '';
    try { ref = document.referrer && new URL(document.referrer).host !== location.host ? document.referrer : ''; } catch (e) { /* référent illisible */ }
    store.set('milos_ref', ref.slice(0, 300));
  }

  function pubContexte() {
    const cookie = (n) => { const m = document.cookie.match('(?:^|; )' + n + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : ''; };
    const fbclid = store.get('milos_fbclid') || '';
    const utm = {};
    CLES_PUB.filter((k) => k.startsWith('utm_')).forEach((k) => { const v = store.get('milos_' + k); if (v) utm[k] = v; });
    return {
      fbp: cookie('_fbp'),
      // Même forme que le cookie que le pixel Meta aurait posé : fb.1.<horodatage>.<fbclid>
      fbc: cookie('_fbc') || (fbclid ? 'fb.1.' + Date.now() + '.' + fbclid : ''),
      ttclid: store.get('milos_ttclid') || '',
      ttp: cookie('_ttp'),
      url: location.origin + location.pathname,
      entree: store.get('milos_entree') || '',
      ref: store.get('milos_ref') || '',
      ua: navigator.userAgent,
      utm
    };
  }

  /* ------------------------------------------------------------------------
     2. Pixels Meta + TikTok — mêmes événements et mêmes valeurs que les landings.
     Purchase porte le numéro de commande comme identifiant : le CRM renvoie le même
     événement par l'API de conversions, et les régies n'en comptent qu'un.
     ------------------------------------------------------------------------ */
  const META = { ViewContent: 'ViewContent', InitiateCheckout: 'InitiateCheckout', Purchase: 'Purchase' };
  const TTOK = { ViewContent: 'ViewContent', InitiateCheckout: 'InitiateCheckout', Purchase: 'PlaceAnOrder' };
  function suivre(nom, params, id) {
    if (APERCU) { console.info('[pixel — non envoyé depuis l\'aperçu]', nom, params, id || ''); return; }
    try { if (window.fbq) window.fbq('track', META[nom], params, id ? { eventID: id } : undefined); } catch (e) { /* ignoré */ }
    try { if (window.ttq) window.ttq.track(TTOK[nom], params, id ? { event_id: id } : undefined); } catch (e) { /* ignoré */ }
  }

  /* ------------------------------------------------------------------------
     3. Le CRM, par le relais Vercel des landings
     Railway est mal joignable depuis l'Algérie (une connexion sur deux échouait le
     16/09/2026) ; Vercel répond. On essaie les relais dans l'ordre, Railway en dernier, et on
     retient celui qui a marché. Une commande peut être renvoyée sans risque : le CRM rend la
     commande déjà créée si le même téléphone recommande la même taille dans les 10 minutes.
     ------------------------------------------------------------------------ */
  const BASES = String(C.api || '').split(/[\s,]+/).map((s) => s.replace(/\/+$/, '')).filter(Boolean);
  function ordreBases() {
    const ok = store.get('milos_crm');
    return ok && BASES.includes(ok) ? [ok].concat(BASES.filter((b) => b !== ok)) : BASES.slice();
  }
  async function appel(url, options) {
    const ctrl = new AbortController();
    const t = setTimeout(() => ctrl.abort(), options ? 20000 : 10000);
    try {
      const r = await fetch(url, Object.assign({ signal: ctrl.signal, credentials: 'omit' }, options));
      const data = await r.json().catch(() => ({}));
      if (!r.ok) {
        const e = new Error(data.error || 'Service indisponible, réessaie dans un instant.');
        e.refus = r.status < 500 && !!data.error;   // réponse du CRM : ne pas insister
        throw e;
      }
      return data;
    } finally { clearTimeout(t); }
  }
  async function api(chemin, corps) {
    const url = chemin + (chemin.includes('?') ? '&' : '?') + 'produit=' + encodeURIComponent(C.key || 'boutique');
    // text/plain : requête « simple », sans aller-retour CORS préalable. Le CRM lit le JSON
    // quel que soit le type annoncé.
    const options = corps ? { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(corps) } : undefined;
    let derniere = null;
    for (const base of ordreBases()) {
      for (let i = 0; i < 2; i++) {
        try {
          const d = await appel(base + url, options);
          store.set('milos_crm', base);
          return d;
        } catch (e) {
          if (e.refus) throw e;
          derniere = e;
          await pause(700 * (i + 1));
        }
      }
    }
    const reseau = !derniere || derniere.name === 'AbortError' || /fetch|network|load/i.test(derniere.message);
    throw new Error(reseau ? 'Connexion difficile. Vérifie ton réseau et réessaie.' : derniere.message);
  }
  // Lectures mises en cache pour la session : passer d'un produit à l'autre ne recharge pas
  // les 54 wilayas ni les communes déjà vues.
  async function lire(chemin, dureeMin) {
    const cle = 'milos_cache_' + chemin;
    try {
      const c = JSON.parse(store.get(cle) || 'null');
      if (c && Date.now() - c.at < dureeMin * 60000) return c.d;
    } catch (e) { /* cache illisible */ }
    const d = await api(chemin);
    store.set(cle, JSON.stringify({ at: Date.now(), d }));
    return d;
  }

  /* ------------------------------------------------------------------------
     4. Sélecteur de taille — t-shirts oversize (même règle que Lake Como)
     On rend la taille HABITUELLE : les mesures d'un oversize ont déjà l'ampleur, en ajouter
     compterait l'oversize deux fois. Le poids porte la carrure ; à poids égal, plus on est
     grand plus on est mince (0,35 kg par cm). Au-delà d'1,85 m, un S ou un M serait trop court.
     ------------------------------------------------------------------------ */
  const RANG = { xs: -1, s: 0, m: 1, l: 2, xl: 3, xxl: 4, '2xl': 4, xxxl: 5, '3xl': 5 };
  const rangDe = (v) => { const k = String(v).toLowerCase().replace(/[^a-z0-9]/g, ''); return k in RANG ? RANG[k] : null; };
  const SEUILS = [63, 74, 85, 96];                 // bornes hautes de S, M, L, XL
  const PLANCHERS = [[192, 3], [185, 2]];          // à partir de 1,92 m : XL mini ; 1,85 m : L mini
  function rangIdeal(h, w) {
    const score = w + (175 - h) * 0.35;
    let i = SEUILS.findIndex((s) => score < s);
    if (i < 0) i = SEUILS.length;
    PLANCHERS.forEach(([cm, mini]) => { if (h >= cm) i = Math.max(i, mini); });
    return i;
  }

  /* ------------------------------------------------------------------------
     5. Le formulaire
     ------------------------------------------------------------------------ */
  class CodForm extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const page = this.closest('product-page');
      const json = (page && page.querySelector('[data-product-json]')) || this.querySelector('[data-cod-product]');
      try { this.product = JSON.parse(json.textContent); } catch (e) { return; }
      this.page = page;
      this.form = this.querySelector('[data-cod-form]');
      this.st = { cfg: null, wilaya: null, communes: [], commune: null, mode: 'domicile', qte: 1, variante: null, envoi: false };
      this.options = $$('[data-cod-option]', this);
      this.brancher();
      this.majVariante(true);
      this.recalc();
      this.charger();
      this.brancherTaille();
      const v = this.st.variante || this.product.variants[0];
      suivre('ViewContent', {
        content_type: 'product', content_ids: [v.sku || String(v.id)], content_name: this.dataset.title,
        value: v.price / 100, currency: 'DZD'
      });
    }

    /* ----- Données du CRM ----- */
    async charger() {
      try {
        this.st.cfg = await lire('/api/public/config', 10);
      } catch (e) { this.panne(e.message); return; }
      const c = this.st.cfg;
      if (c.actif === false) { this.panne('Les commandes sont momentanément fermées.'); return; }
      const sel = this.form.elements.wilayaCode;
      sel.innerHTML = '<option value="">' + esc(this.dataset.tWilaya) + '</option>'
        + c.wilayas.map((w) => '<option value="' + w.code + '">' + String(w.code).padStart(2, '0') + ' — ' + esc(w.name) + '</option>').join('');
      sel.disabled = false;
      this.recalc();
    }
    panne(msg) {
      const box = $('[data-cod-error]', this);
      box.hidden = false;
      box.textContent = msg + ' Recharge la page dans un instant.';
      $('[data-cod-submit]', this).disabled = true;
    }
    async choisirWilaya(code) {
      const selC = this.form.elements.commune;
      const st = this.st;
      st.wilaya = (st.cfg && st.cfg.wilayas.find((w) => String(w.code) === String(code))) || null;
      st.commune = null;
      this.net(selC); this.net(this.form.elements.wilayaCode);
      if (!st.wilaya) {
        selC.disabled = true;
        selC.innerHTML = '<option value="">' + esc(this.dataset.tCommuneAvant) + '</option>';
        this.recalc();
        return;
      }
      selC.disabled = true;
      selC.innerHTML = '<option value="">…</option>';
      this.recalc();
      try {
        const d = await lire('/api/public/communes?wilaya=' + encodeURIComponent(code), 30);
        if (String(this.form.elements.wilayaCode.value) !== String(code)) return;   // choix changé entre-temps
        st.communes = d.communes || [];
        selC.innerHTML = '<option value="">' + esc(this.dataset.tCommune) + '</option>'
          + st.communes.map((c) => '<option value="' + esc(c.name) + '">' + esc(c.name) + '</option>').join('');
        selC.disabled = false;
      } catch (e) {
        selC.innerHTML = '<option value="">—</option>';
        this.mauvais(selC, 'Impossible de charger les communes. Réessaie.');
      }
    }

    /* ----- Variante ----- */
    choix() {
      return this.options.map((fs) => { const r = $('input[type=radio]:checked', fs); return r ? r.value : null; });
    }
    majVariante(silencieux) {
      const p = this.product;
      const choix = this.choix();
      let v = null;
      if (p.variants.length === 1) v = p.variants[0];
      else if (choix.every(Boolean)) v = p.variants.find((x) => x.options.every((o, i) => o === choix[i])) || null;
      this.st.variante = v;
      // Pastilles : une valeur est grisée si aucune variante disponible ne la porte avec les
      // autres choix déjà faits.
      this.options.forEach((fs, pos) => {
        $$('input[type=radio]', fs).forEach((input) => {
          const dispo = p.variants.some((x) => x.available && x.options[pos] === input.value
            && x.options.every((o, i) => i === pos || !choix[i] || o === choix[i]));
          input.nextElementSibling.classList.toggle('is-unavailable', !dispo);
        });
        const chosen = $('[data-cod-chosen]', fs);
        if (chosen) chosen.textContent = choix[pos] || '';
      });
      if (v && this.page) {
        if (typeof this.page.updatePrice === 'function') this.page.updatePrice(v);
        if (v.featured_media && typeof this.page.goToMedia === 'function' && !silencieux) this.page.goToMedia(v.featured_media.id);
      }
      this.recalc();
    }

    /* ----- Calcul affiché (le CRM refait le même à la réception) ----- */
    // null = destination pas encore choisie ; 0 = offerte ; -1 = pas de tarif ZR → « à confirmer »
    frais() {
      const st = this.st, src = st.commune || st.wilaya;
      if (!src) return null;
      if (st.cfg && st.cfg.livraisonOfferte) return 0;
      const f = st.mode === 'stopdesk' ? src.stopdesk : src.domicile;
      return f > 0 ? f : -1;
    }
    tarif(v) {
      if (v === null || v === undefined) return this.dataset.tSelon;
      if (v < 0) return this.dataset.tAConfirmer;
      if (v === 0) return this.dataset.tOfferte;
      return money(v);
    }
    recalc() {
      const st = this.st;
      const v = st.variante || this.product.variants[0];
      const prix = v.price / 100;
      const sous = prix * st.qte, f = this.frais();
      $('[data-cod-var]', this).textContent = (st.variante ? (st.variante.title === 'Default Title' ? '' : st.variante.title + ' · ') : '') + '×' + st.qte;
      $('[data-cod-qty-v]', this).textContent = st.qte;
      $('[data-cod-sub]', this).textContent = money(sous);
      $('[data-cod-fee-label]', this).textContent = st.mode === 'stopdesk' ? this.dataset.tFeeDesk : this.dataset.tFeeHome;
      $('[data-cod-fee]', this).textContent = this.tarif(f);
      this.rouler($('[data-cod-total]', this), sous + (f > 0 ? f : 0));
      $('[data-cod-total-suffix]', this).textContent = f !== null && f < 0 ? ' ' + this.dataset.tPlusLivraison : '';
      const src = st.commune || st.wilaya, offert = st.cfg && st.cfg.livraisonOfferte;
      $('[data-fee-home]', this).textContent = src ? this.tarif(offert ? 0 : (src.domicile || -1)) : this.dataset.tSelon;
      $('[data-fee-desk]', this).textContent = src ? this.tarif(offert ? 0 : (src.stopdesk || -1)) : this.dataset.tSelon;
      $('[data-cod-adresse]', this).hidden = st.mode !== 'domicile';
      if (v.featured_image || (v.featured_media && v.featured_media.preview_image)) {
        const src2 = (v.featured_image && v.featured_image.src) || v.featured_media.preview_image.src;
        const img = $('[data-cod-thumb]', this);
        if (img && src2) img.src = src2 + (src2.includes('?') ? '&' : '?') + 'width=200';
      }
    }
    rouler(el, vers) {
      const de = Number(el.dataset.v || 0);
      el.dataset.v = vers;
      if (REDUCED || de === vers) { el.textContent = money(vers); return; }
      const t0 = performance.now(), d = 420;
      const pas = (t) => {
        const p = Math.min(1, (t - t0) / d), e = 1 - Math.pow(1 - p, 3);
        el.textContent = money(de + (vers - de) * e);
        if (p < 1) requestAnimationFrame(pas);
      };
      requestAnimationFrame(pas);
    }

    /* ----- Validation ----- */
    champ(el) { return el && (el.closest('.cod__field') || el.closest('fieldset')); }
    net(el) { const f = this.champ(el); if (f) f.classList.remove('is-bad'); }
    mauvais(el, msg) {
      const f = this.champ(el);
      if (!f) return;
      f.classList.add('is-bad');
      const e = $('[data-err]', f);
      if (e) e.textContent = msg;
    }
    static telIntl(v) {
      let d = String(v || '').replace(/\D/g, '');
      if (d.startsWith('00213')) d = d.slice(5); else if (d.startsWith('213')) d = d.slice(3); else if (d.startsWith('0')) d = d.slice(1);
      return '+213' + d;
    }
    valider() {
      const f = this.form.elements;
      let premier = null;
      const bad = (el, msg) => { this.mauvais(el, msg); if (!premier) premier = el; };
      this.options.forEach((fs) => { if (!$('input[type=radio]:checked', fs)) bad($('input[type=radio]', fs), 'Choisis ta ' + String($('legend span', fs).firstChild.textContent).trim().toLowerCase() + '.'); });
      if (this.product.variants.length > 1 && this.options.length && !this.st.variante && !premier) bad($('input[type=radio]', this.options[0]), 'Cette combinaison n\'existe pas.');
      if (f.nomComplet.value.trim().length < 3) bad(f.nomComplet, 'Ton nom, s\'il te plaît.');
      if (!/^\+213[5-7]\d{8}$/.test(CodForm.telIntl(f.telephone.value))) bad(f.telephone, 'Numéro invalide — ex. 0555 12 34 56.');
      if (!f.wilayaCode.value) bad(f.wilayaCode, 'Choisis ta wilaya.');
      if (!f.commune.value) bad(f.commune, 'Choisis ta commune.');
      if (premier) {
        const cible = premier.closest('fieldset, .cod__field') || premier;
        cible.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'center' });
        if (premier.type !== 'radio') premier.focus({ preventScroll: true });
      }
      return !premier;
    }

    /* ----- Envoi ----- */
    async envoyer(ev) {
      ev.preventDefault();
      const st = this.st;
      if (st.envoi) return;
      $$('.is-bad', this).forEach((x) => x.classList.remove('is-bad'));
      const box = $('[data-cod-error]', this);
      box.hidden = true;
      if (!this.valider()) return;
      const f = this.form.elements;
      const btn = $('[data-cod-submit]', this);
      st.envoi = true; btn.classList.add('is-loading'); btn.disabled = true;
      const v = st.variante || this.product.variants[0];
      const tel = CodForm.telIntl(f.telephone.value);
      try {
        const r = await api('/api/public/order', {
          nomComplet: f.nomComplet.value.trim(), telephone: tel,
          wilayaCode: f.wilayaCode.value, commune: f.commune.value, adresse: f.adresse.value.trim(),
          handle: this.dataset.handle, variantId: v.id, quantite: st.qte, livraison: st.mode,
          website: f.website.value, pub: pubContexte(), essai: APERCU || undefined
        });
        this.succes(r, tel, v);
      } catch (e) {
        box.hidden = false;
        box.textContent = e.message;
      } finally {
        st.envoi = false; btn.classList.remove('is-loading'); btn.disabled = false;
      }
    }
    /* ----- Panier abandonné -----
       La personne s'en va (onglet fermé, appli quittée, autre page) avec un nom et un numéro
       valides sans avoir commandé : le CRM reçoit ce qui était rempli et le range dans l'onglet
       « Abandonnées », à relancer par téléphone — comme le faisait Webi. S'il revient et
       commande, le CRM retire le panier tout seul. sendBeacon part même pendant la fermeture. */
    envoyerPanier() {
      if (this.commande || this.st.envoi || !BASES.length) return;
      const f = this.form.elements;
      const tel = CodForm.telIntl(f.telephone.value);
      const nom = f.nomComplet.value.trim();
      if (nom.length < 2 || !/^\+213[5-7]\d{8}$/.test(tel)) return;
      const v = this.st.variante;
      const corps = {
        nomComplet: nom, telephone: tel, wilayaCode: f.wilayaCode.value, commune: f.commune.value,
        adresse: f.adresse.value.trim(), handle: this.dataset.handle, variantId: v ? v.id : null,
        quantite: this.st.qte, livraison: this.st.mode, website: f.website.value
      };
      const sig = JSON.stringify(corps);
      if (sig === this.panierEnvoye) return;   // rien de neuf depuis le dernier envoi
      this.panierEnvoye = sig;
      corps.pub = pubContexte();
      if (APERCU) corps.essai = true;
      const url = ordreBases()[0] + '/api/public/panier?produit=' + encodeURIComponent(C.key || 'boutique');
      const body = JSON.stringify(corps);
      try {
        if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([body], { type: 'text/plain;charset=UTF-8' }))) return;
      } catch (e) { /* on passe à fetch */ }
      try { fetch(url, { method: 'POST', body, keepalive: true, credentials: 'omit', headers: { 'Content-Type': 'text/plain;charset=UTF-8' } }); } catch (e) { /* tant pis */ }
    }

    succes(r, tel, v) {
      this.commande = true;
      if (!r.doublon) {
        const sku = r.sku || v.sku || String(v.id);
        const prix = r.prix || v.price / 100;
        suivre('Purchase', {
          content_type: 'product', content_ids: [sku],
          contents: [{ id: sku, quantity: this.st.qte, item_price: prix }],
          num_items: this.st.qte,
          // Hors livraison : même règle que le CRM (caCommande) et l'API de conversions.
          value: r.total - (Number(r.frais) || 0), currency: 'DZD'
        }, r.commande);
      }
      this.form.hidden = true;
      $('.cod__head', this).hidden = true;
      const d = $('[data-cod-done]', this);
      d.hidden = false;
      $('[data-done-num]', d).textContent = r.commande;
      $('[data-done-tel]', d).textContent = tel.replace('+213', '0').replace(/(\d{4})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4');
      $('[data-done-total]', d).textContent = money(r.total);
      if (r.essai) $('[data-done-essai]', d).hidden = false;
      const bar = $('[data-sticky-buy]');
      if (bar) bar.remove();
      if (window.MilosFomo) window.MilosFomo.stop();
      this.ouvrirConfirmation(d);
    }
    // Grande fenêtre par-dessus la page, déplacée dans <body> pour échapper aux colonnes
    // collantes ; à la fermeture elle reprend la place du formulaire, en encart.
    ouvrirConfirmation(d) {
      const place = document.createComment('cod-done');
      d.before(place);
      document.body.appendChild(d);
      d.classList.add('is-popup');
      document.body.classList.add('is-locked');
      const btn = $('[data-done-close]', d);
      const fermer = () => {
        d.classList.remove('is-popup');
        document.body.classList.remove('is-locked');
        place.replaceWith(d);
        btn.hidden = true;
        document.removeEventListener('keydown', echap);
        d.removeAttribute('aria-modal');
        d.setAttribute('role', 'status');
        d.scrollIntoView({ behavior: 'auto', block: 'center' });
      };
      const echap = (e) => { if (e.key === 'Escape') fermer(); };
      btn.addEventListener('click', fermer, { once: true });
      document.addEventListener('keydown', echap);
      requestAnimationFrame(() => btn.focus({ preventScroll: true }));
    }

    /* ----- Écouteurs ----- */
    brancher() {
      const f = this.form;
      this.options.forEach((fs) => fs.addEventListener('change', (e) => { if (e.target.type !== 'radio') return; this.net(e.target); this.majVariante(); }));
      f.elements.wilayaCode.addEventListener('change', (e) => this.choisirWilaya(e.target.value));
      f.elements.commune.addEventListener('change', (e) => {
        this.st.commune = this.st.communes.find((c) => c.name === e.target.value) || null;
        this.net(e.target); this.recalc();
      });
      $$('[name=livraison]', f).forEach((r) => r.addEventListener('change', () => { this.st.mode = r.value; this.recalc(); }));
      $$('[data-cod-qty]', f).forEach((b) => b.addEventListener('click', () => {
        this.st.qte = Math.max(1, Math.min(3, this.st.qte + Number(b.dataset.codQty)));
        this.recalc();
      }));
      ['nomComplet', 'telephone'].forEach((n) => f.elements[n].addEventListener('input', (e) => this.net(e.target)));
      f.addEventListener('submit', (e) => this.envoyer(e));
      // InitiateCheckout à la première vraie saisie, une seule fois par page.
      let commence = false;
      const debut = () => {
        if (commence) return;
        commence = true;
        const v = this.st.variante || this.product.variants[0];
        suivre('InitiateCheckout', { content_type: 'product', content_ids: [v.sku || String(v.id)], num_items: this.st.qte, value: v.price / 100 * this.st.qte, currency: 'DZD' });
      };
      f.addEventListener('input', debut);
      f.addEventListener('change', debut);
      // Sur mobile, `visibilitychange` est le seul signal fiable quand on quitte l'appli ;
      // `pagehide` couvre la navigation vers une autre page et la fermeture sur ordinateur.
      document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') this.envoyerPanier(); });
      window.addEventListener('pagehide', () => this.envoyerPanier());
    }

    /* ----- Sélecteur de taille ----- */
    brancherTaille() {
      const fit = $('[data-fit]', this);
      const toggle = $('[data-fit-toggle]', this);
      const fsTaille = $('[data-cod-size]', this);
      if (!fit || !toggle || !fsTaille) return;
      const valeurs = $$('input[type=radio]', fsTaille).map((i) => ({ input: i, rang: rangDe(i.value) })).filter((x) => x.rang !== null);
      if (valeurs.length < 2) { toggle.hidden = true; return; }
      const hh = $('[data-fit-h]', fit), ww = $('[data-fit-w]', fit), pick = $('[data-fit-pick]', fit);
      toggle.addEventListener('click', () => {
        fit.hidden = !fit.hidden;
        toggle.setAttribute('aria-expanded', String(!fit.hidden));
        if (!fit.hidden) maj();
      });
      // Trois pulsations quand le bloc arrive à l'écran, une fois par page : l'œil le repère
      // avant de choisir une taille au hasard (animation dans cod.css, coupée si mouvement réduit).
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((es) => {
          if (es.some((e) => e.isIntersecting)) { toggle.classList.add('is-signal'); io.disconnect(); }
        }, { threshold: 0.9 });
        io.observe(toggle);
      }
      const remplir = (i) => i.style.setProperty('--p', ((i.value - i.min) / (i.max - i.min) * 100).toFixed(1));
      const maj = () => {
        const h = Number(hh.value), w = Number(ww.value);
        $('[data-fit-out=h]', fit).textContent = h + ' cm';
        $('[data-fit-out=w]', fit).textContent = w + ' kg';
        remplir(hh); remplir(ww);
        const ideal = rangIdeal(h, w);
        const dispo = valeurs.filter((x) => !x.input.nextElementSibling.classList.contains('is-unavailable'));
        const exact = valeurs.find((x) => x.rang === ideal) || valeurs.slice().sort((a, b) => Math.abs(a.rang - ideal) - Math.abs(b.rang - ideal))[0];
        const proche = dispo.slice().sort((a, b) => Math.abs(a.rang - ideal) - Math.abs(b.rang - ideal))[0] || null;
        const el = $('[data-fit-size]', fit);
        // On compare à la cible en attente, pas au texte affiché : deux curseurs bougés coup sur
        // coup lançaient deux fondus, et le premier pouvait écraser le second (L → XL).
        if (el.dataset.cible !== exact.input.value) {
          el.dataset.cible = exact.input.value;
          el.classList.add('is-swap');
          setTimeout(() => { el.textContent = el.dataset.cible; el.classList.remove('is-swap'); }, REDUCED ? 0 : 170);
        }
        const why = $('[data-fit-why]', fit);
        let choix = proche;
        if (!proche) { why.textContent = 'Tout est épuisé pour le moment.'; choix = null; }
        else if (proche === exact || proche.rang === exact.rang) {
          why.textContent = fit.dataset.coupe === 'regular'
            ? 'Coupe regular : ajustée sans serrer. Pour un effet oversize, prends une taille au-dessus.'
            : 'Coupe oversize : épaules tombantes, tombé ample sans flotter.';
        }
        else if (Math.abs(proche.rang - ideal) >= 2) {
          why.innerHTML = 'La <b>' + esc(exact.input.value) + '</b> est épuisée, et il ne reste rien d\'assez proche pour que ça tombe bien.';
          choix = null;
        } else {
          why.innerHTML = 'La <b>' + esc(exact.input.value) + '</b> est épuisée. La ' + esc(proche.input.value)
            + ' donnera un tombé ' + (proche.rang > ideal ? 'plus ample.' : 'plus ajusté.');
        }
        pick.hidden = !choix;
        if (choix) {
          pick.dataset.valeur = choix.input.value;
          if (pick.dataset.pose !== choix.input.value) pick.querySelector('span').textContent = 'Choisir la taille ' + choix.input.value;
        }
      };
      [hh, ww].forEach((i) => i.addEventListener('input', maj));
      pick.addEventListener('click', () => {
        const cible = valeurs.find((x) => x.input.value === pick.dataset.valeur);
        if (!cible) return;
        cible.input.checked = true;
        cible.input.dispatchEvent(new Event('change', { bubbles: true }));
        pick.dataset.pose = cible.input.value;
        pick.querySelector('span').textContent = 'Taille ' + cible.input.value + ' choisie';
        setTimeout(() => { fit.hidden = true; toggle.setAttribute('aria-expanded', 'false'); }, 650);
      });
    }
  }
  if (!customElements.get('cod-form')) customElements.define('cod-form', CodForm);

  /* ------------------------------------------------------------------------
     6. Preuve sociale — « Yasmine · Oran a commandé… »
     Prénoms et wilayas viennent des vraies commandes (CRM, /api/public/recentes), produits
     de la boutique ; ils sont combinés au hasard, donc jamais la commande d'une vraie
     personne. Mêmes règles que la landing : jamais pendant une saisie ni onglet caché, jamais
     après une commande, un plafond par visite, une croix qui arrête tout pour la session.
     Le compte et le prochain passage survivent au changement de page.
     ------------------------------------------------------------------------ */
  const F = C.fomo || {};
  const Fomo = {
    stopped: false,
    timer: null,
    stop() {
      this.stopped = true;
      clearTimeout(this.timer);
      this.cacher();
      store.set('milos_fomo_off', '1');
    },
    cacher() {
      const t = $('[data-fomo]');
      if (!t) return;
      t.classList.remove('is-on');
      setTimeout(() => { if (!t.classList.contains('is-on')) t.hidden = true; }, 600);
    },
    tirage(liste) {
      const total = liste.reduce((n, x) => n + x.poids, 0);
      let r = Math.random() * total;
      for (const x of liste) { r -= x.poids; if (r <= 0) return x; }
      return liste[0];
    },
    async donnees() {
      try { return await lire('/api/public/recentes', 60); }
      catch (e) {
        // CRM injoignable : un petit jeu de secours, pour ne pas rester muet.
        return {
          prenoms: ['Yasmine', 'Amine', 'Sarah', 'Walid', 'Meriem', 'Yacine', 'Lina', 'Rayan', 'Imene', 'Karim'],
          wilayas: [{ nom: 'Alger', poids: 30 }, { nom: 'Oran', poids: 12 }, { nom: 'Boumerdès', poids: 7 }, { nom: 'Blida', poids: 6 }, { nom: 'Constantine', poids: 5 }]
        };
      }
    },
    async init() {
      const t = $('[data-fomo]');
      const jsonEl = $('[data-fomo-produits]');
      if (!t || !jsonEl || !F.actif || store.get('milos_fomo_off')) return;
      let produits = [];
      try { produits = JSON.parse(jsonEl.textContent).filter((p) => p && p.u && p.t); } catch (e) { return; }
      if (!produits.length) return;
      this.produits = produits;
      $('[data-fomo-x]', t).addEventListener('click', (e) => { e.preventDefault(); this.stop(); });
      const prochain = Number(store.get('milos_fomo_next') || 0);
      const attente = Math.max((F.delai || 14) * 1000, prochain - Date.now());
      this.timer = setTimeout(() => this.montrer(), attente);
    },
    async montrer() {
      if (this.stopped) return;
      const compte = Number(store.get('milos_fomo_n') || 0);
      if (compte >= (F.max || 7)) return;
      const occupe = document.activeElement && /^(INPUT|SELECT|TEXTAREA)$/.test(document.activeElement.tagName);
      if (occupe || document.hidden || document.body.classList.contains('is-locked')) {
        this.timer = setTimeout(() => this.montrer(), 12000);
        return;
      }
      if (!this.data) this.data = await this.donnees();
      const d = this.data;
      if (!d.prenoms || !d.prenoms.length || !d.wilayas || !d.wilayas.length) return;
      const prenom = d.prenoms[Math.floor(Math.random() * d.prenoms.length)];
      const wilaya = this.tirage(d.wilayas).nom;
      const p = this.produits[Math.floor(Math.random() * this.produits.length)];
      const t = $('[data-fomo]');
      $('[data-fomo-t]', t).textContent = prenom + ' · ' + wilaya;
      $('[data-fomo-s]', t).textContent = p.t;
      $('[data-fomo-when]', t).textContent = (F.verbe || 'a commandé') + ' · il y a ' + (2 + Math.floor(Math.random() * 37)) + ' min';
      $('[data-fomo-link]', t).href = p.u;
      const img = $('[data-fomo-img]', t);
      if (p.i) { img.src = p.i; img.hidden = false; } else img.hidden = true;
      t.hidden = false;
      requestAnimationFrame(() => t.classList.add('is-on'));
      store.set('milos_fomo_n', String(compte + 1));
      const suivant = 28000 + Math.random() * 32000;
      store.set('milos_fomo_next', String(Date.now() + suivant));
      setTimeout(() => this.cacher(), 6500);
      this.timer = setTimeout(() => this.montrer(), suivant);
    }
  };
  window.MilosFomo = Fomo;

  const boot = () => Fomo.init();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
